export default __webpack_public_path__ + "static/media/image3.c28f16e9.jpeg";